import Layout from './Layout.jsx';
import Profile from './Profile.jsx';
import SolvedJoke from './SolvedJoke.jsx';
import HumorQuiz from './HumorQuiz.jsx';
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import store from "./store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { withRouter } from "../utils/withRouter.jsx";

const LayoutWithRouter = withRouter(Layout);
const SolvedJokeWithRouter = withRouter(SolvedJoke);

const container = document.getElementById("app");

createRoot(container || document.createElement('div')).render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/joke/:id" element={<LayoutWithRouter />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/solved/:id" element={<SolvedJokeWithRouter />} />
        <Route path="/humor-quiz" element={<HumorQuiz />} />
        <Route path="/" element={<LayoutWithRouter />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);
